import {
  ChartBar,
  GitPullRequest,
  ShieldCheck,
  Wrench,
} from '@phosphor-icons/react';
import { Text } from '@fragments-sdk/ui';
import s from '../findings.module.scss';

export function RepositoryFindingsScoreboard({
  open,
  resolved,
  ignored,
  matched,
  safeFixes,
}: {
  open: number;
  resolved: number;
  ignored: number;
  matched: number;
  safeFixes: number;
}) {
  const total = open + resolved + ignored;
  const resolvedPct = total > 0 ? Math.round((resolved / total) * 100) : 0;
  const tiles = [
    {
      label: 'Open findings',
      value: open,
      delta: `${matched} matched`,
      icon: ShieldCheck,
      tone: open > 0 ? 'danger' : 'success',
    },
    {
      label: 'Safe fixes',
      value: safeFixes,
      delta: 'Ready for PR',
      icon: Wrench,
      tone: safeFixes > 0 ? 'accent' : 'neutral',
    },
    {
      label: 'Resolved',
      value: `${resolvedPct}%`,
      delta: `${resolved} resolved`,
      icon: ChartBar,
      tone: 'neutral',
    },
    {
      label: 'Ignored',
      value: ignored,
      delta: 'Waived findings',
      icon: GitPullRequest,
      tone: 'neutral',
    },
  ] as const;

  return (
    <div className={s.findingsScoreboard} aria-label="Findings summary">
      {tiles.map((tile) => {
        const Icon = tile.icon;
        return (
          <div
            key={tile.label}
            className={s.findingsScoreTile}
            data-tone={tile.tone}
          >
            <span className={s.findingsScoreHead}>
              <span className={s.findingsScoreIcon} aria-hidden="true">
                <Icon size={13} />
              </span>
              <Text
                as="span"
                font="mono"
                size="2xs"
                color="tertiary"
                className={s.findingsScoreLabel}
              >
                {tile.label}
              </Text>
            </span>
            <Text as="strong" size="xl" weight="medium" tabularNums>
              {tile.value}
            </Text>
            <Text
              as="span"
              font="mono"
              size="2xs"
              className={s.findingsScoreDelta}
            >
              {tile.delta}
            </Text>
          </div>
        );
      })}
    </div>
  );
}
